module.exports = __webpack_public_path__ + "img/bonjour-logo.d982beab.svg";